<template>
    <v-col v-if="processus && headers">
        <v-data-table
            :headers="headers"
            :items="processus"
        >
        <template v-slot:[`item.action`]="{item}">
            <v-btn icon @click="editer(item)">
                <v-icon>edit</v-icon>
            </v-btn>
        </template>
        </v-data-table>
        <v-dialog
            v-model="dialogProcessus"
            persistent
            max-width="500px"
            transition="dialog-transition"
        >
        <BaseBlock>
            <v-form lazy-validation ref="formProcessus" v-model="formProcessus">
                <v-text-field
                    v-model="process.name"
                    name="Nom"
                    label="Nom"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                ></v-text-field>
                <v-text-field
                    v-model="process.rubrique"
                    name="Rubrique"
                    label="Rubrique"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                ></v-text-field>
                <v-radio-group
                    v-model="process.cache"
                    name="Tuile caché ?"
                    label="Tuile caché ?"
                    required
                    :rules="[(value) => value != null || 'Champ requis.']"
                >
                    <v-radio label="Oui" :value="true">
                    </v-radio>
                    <v-radio label="Non" :value="false">
                    </v-radio>
                </v-radio-group>
                <v-text-field
                    v-model="process.route"
                    name="Chemin d'accès"
                    label="Chemin d'accès"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                ></v-text-field>
                <v-text-field
                    v-model="process.icon"
                    name="Icon"
                    label="Icône de la tuile"
                    required
                    :rules="[(value) => !!value || 'Champ requis.']"
                ></v-text-field>
                <v-radio-group v-model="process.temoin" name="Temoin" required label="Temoin" :rules="[(value) => value != null || 'Champ requis.']">
                    <v-radio label="Personnel" value="Personnel"></v-radio>
                    <v-radio label="DRH" value="DRH"></v-radio>
                    <v-radio label="Administration" value="Admin"></v-radio>
                </v-radio-group>
            <v-btn color="success" :disabled="!formProcessus" @click="valider()">Valider</v-btn>
            <v-btn color="warning" @click="annuler()">Annuler</v-btn>
            <v-btn color="info" @click="fermer()">Fermer</v-btn>
            </v-form>
        </BaseBlock>
        </v-dialog>
    </v-col>
</template>

<script>
import ApiProcessusRepository from "@/repositories/ApiProcessusRepository";
import BaseBlock from "@/components/base/BaseBlock";

export default {
    components:
    {
        BaseBlock
    },
    data()
    {
        return {
            process: 
            {
                id: null,
                rubrique: null,
                name: null,
                cache: null,
                route: null,
                icon: null,
                temoin: null
            },
            processSave: {},
            processus: null,
            headersKeys: null,
            headers: [],
            dialogProcessus: false,
            formProcessus: false,
            indexOf: null,
        }
    },
    async mounted()
    {
        this.processus = await ApiProcessusRepository.getAll();
        console.log(this.processus);
        this.headersKeys = Object.keys(this.processus[0]);
        this.headersKeys.forEach(element => {
            this.headers.push({text: element,value: element})
        });
        this.headers.push({text: "Action", value: "action"});
    },
    methods:
    {
        editer(item)
        {
            Object.assign(this.process, item);
            Object.assign(this.processSave, item);
            this.indexOf = this.processus.indexOf(item);
            this.dialogProcessus = true;
        },
        fermer()
        {
            this.process = Object.assign({});
            this.$refs.formProcessus.reset();
            this.dialogProcessus = false;
            this.indexOf = null;
        },
        annuler()
        {
            Object.assign(this.process, this.processSave);
        },
        async valider()
        {
            if(this.$refs.formProcessus.validate())
            {
            await ApiProcessusRepository.update(this.process);
            this.processus[this.indexOf] = this.process;
            this.processus = this.processus;
            console.log(this.processus[this.indexOf])
            this.fermer();
            }
        }
    }
}
</script>